import {useLocation} from 'react-router-dom';

export type EditorMode = 'create' | 'edit' | 'view';

export interface EditorLocationState {
    reference: string | undefined;
    mode: EditorMode;
    workerId: string | undefined;
    initialDate: number | undefined
}

export function useEditorLocation(): EditorLocationState {
    const {hash, search} = useLocation();
    const queryParams = new URLSearchParams(search);
    const reference = hash === '' ? undefined : hash.substr(1);

    const mode = queryParams.get('mode') ?? 'view';

    const workerId = queryParams.get('workerId');
    console.log("query", workerId);
    return {
        reference,
        mode: (['create', 'edit', 'view'].includes(mode)
            ? mode
            : 'view') as EditorMode,
        workerId: workerId ?? undefined,
        initialDate: queryParams.get('initialDate') ? Number(queryParams.get('initialDate')) : undefined
    }
}
